/* eslint-disable arrow-body-style */
import * as React from "react";
import {observer} from "mobx-react";

import "./project-perimeter-analysis.scss";

import {RisikoanalyseStore} from "../../../../stores/risikoanalyse-store-mobx";
import {AppState} from "../../app-mobx";
import {UiState} from "../../../../core/ui-state";

import {autorun} from "mobx";
import {MapState} from "../../../../core/map-state";

import * as d3 from "d3";

import EsriPopup from "@arcgis/core/widgets/Popup";
import FeatureTable from "@arcgis/core/widgets/FeatureTable";
import PopupTemplate from "@arcgis/core/PopupTemplate";
import {TopicConfiguration} from "../../../../config/topic-configuration";
import ButtonMenuItem from "@arcgis/core/widgets/FeatureTable/Grid/support/ButtonMenuItem";
import TableTemplate from "@arcgis/core/widgets/FeatureTable/support/TableTemplate";
import {Building} from "../../../../models/building";

// TODO: auf react context umstellen
export interface ProjectPerimeterAnalysisProps {
    appStore: AppState;
    uiStore: UiState;
    mapStore: MapState;
    risikoanalyse: RisikoanalyseStore;
}

@observer
export class ProjectPerimeterAnalysis extends React.Component<ProjectPerimeterAnalysisProps, any> {
    autorunDisposers: any[] = [];
    widgetKey = "project-perimeter-analysis";
    svg: d3.Selection<SVGSVGElement | null, undefined, null, undefined>;
    tableRef: any;
    graphRef: any;

    constructor(props: ProjectPerimeterAnalysisProps) {
        super(props);

        this.state = {
            featureTable: null, // ESRI FeatureTable Widget
            artNames: null,
            bekampfungsmassnahmen: null,
            populationsEntwicklung: null,
            zaehleinheiten: null,
            topic: null  // remember topic
        };

        // this.svg = d3.create("svg");
        this.tableRef = React.createRef();
        this.graphRef = React.createRef();
    }

    componentDidMount() {
        this.autorunDisposers.push(
            autorun((loadingReaction: any) => {
                const {risikoanalyse, mapStore, appStore} = this.props;

                if (!risikoanalyse.apiLoaded) {
                    return null;
                }

                if (!mapStore?.map || !mapStore?.view) {
                    return;
                }
                loadingReaction.dispose();

                this.autorunDisposers.push(
                    autorun(() => {
                        const topic = appStore.subtopic;
                        this.updateFeatureTableLayer(topic);
                    })
                );

                this.autorunDisposers.push(
                    autorun(() => {
                        const perimeterGeometry = risikoanalyse.perimeterGeometry;
                        const timeExtent = risikoanalyse.timeExtent;
                        this.selectFeatures(perimeterGeometry, timeExtent);
                    })
                );

                this.initFeatureTable();
                this.initGraph();

                this.setState({
                    isLoading: false
                });

                // load domains
                this.loadDomains();
            })
        );
    }

    componentWillUnmount() {
        this.autorunDisposers.forEach((dispose: any) => {
            dispose();
        });
        this.autorunDisposers.length = 0;
    }

    render() {
        // const {risikoanalyse, mapStore} = this.props;
        // const {data, artNames} = this.state;

        // const dataToVisualize = new Map<string, any>();
        // data.forEach((building: Building) => {
        //     const artName = artNames ? artNames.get(building.artId.toString()) : building.artId;
        //     console.log(artName);
        //     if (!dataToVisualize.has(artName)) {
        //         const entry = {name: artName, frequency: 1};
        //         dataToVisualize.set(artName, entry);
        //     } else {
        //         let entry = dataToVisualize.get(artName);
        //         entry.frequency++;
        //     }
        // });

        // TODO GRK: create graph
        // data.toJSON is not a function -> how to convert?
        // const store = risikoanalyse.LeitartStore;   // TODO GRK: do for other stores as well
        // const pieChart = MediaContent.fromJSON(store.toJSON(data));
        // store.layer.popupTemplate.content = [pieChart];
        //
        // return store.layer.popupTemplate.toString();

        // editorRef.current = this.createGraph();

        // this.graphRef.current = d3.create("svg");
        // const svg = d3.select(this.graphRef.current);

        // const svg = this.createGraph(dataToVisualize.values());

        // const svg = this.createGraph(tmp);
        // this.saveSvg(svg, "tmp.svg");

        // const featureTable = new FeatureTable({
        //     view: mapStore?.view, // The view property must be set for the select/highlight to work
        //     layer: risikoanalyse.LeitartStore.layer,
        //     container: "feature-table" // the table must be assigned to the container via the constructor
        // });

        return (
            <>
                <div id="graph" ref={this.graphRef} />
                <div id="feature-table" ref={this.tableRef} />
            </>
        );

        // <div ref={editorRef}>
        //     <GraphComponent
        //         setRef={this.graphRef}
        //     />
        // </div>
    }

    // This function is called when user completes drawing a rectangle
    // on the map. Use the rectangle to select features in the layer and table
    private selectFeatures(geometry: __esri.Geometry | null, timeExtent: __esri.TimeExtent) {
        const {risikoanalyse} = this.props;
        const {featureTable} = this.state;

        if (!featureTable) {
            return;
        }

        featureTable.filterGeometry = geometry;
        featureTable.refresh();
        featureTable.timeExtent = timeExtent;

        if(!geometry) {
            risikoanalyse.setData(null);
            return;
        }

        // const store = risikoanalyse.getStoreByTopic(appStore.subtopic);
        // store.queryFeaturesInView(geometry, timeExtent, "intersects").then((result) => {
        //     popup.features = result?.map((building) => building.feature);
        //
        //     // risikoanalyse.setPerimeterSelected(true);
        //     // // TODO GRK: implement graph
        //
        //     console.log("query features by geometry: " + result);
        //     risikoanalyse.setData(result);      // TODO GRK: Zugriff auf Popup features statt query
        // });

        // add export button again after refresh
        // export table data
        featureTable.when().then(() => {
            const newMenuItem: ButtonMenuItem = {
                label: "Exportieren",
                clickFunction: (event) => {
                    console.log("Clicked!");
                    this.exportData();
                }
            };
            featureTable.menu.items.push(newMenuItem);
        });
    }

    private initGraph(): void {
        const {mapStore} = this.props;
        const popup = new EsriPopup({
            view: mapStore.view,
            container: this.graphRef.current,
            content: "test",
        });

        // TODO GRK: set MediaContent as content
        const popupTemplate = new PopupTemplate();
        popupTemplate.content = "<p>As of 2015, <b>{MARRIEDRATE}%</b> of the" +
            " population in this zip code is married.</p>" +
            "<ul><li>{MARRIED_CY} people are married</li>" +
            "<li>{NEVMARR_CY} have never married</li>" +
            "<li>{DIVORCD_CY} are divorced</li><ul>";

        this.setState({
            popup
        });
    }

    private initFeatureTable(): void {
        const {risikoanalyse, mapStore, appStore} = this.props;

        const tableTemplate = new TableTemplate({
            columnTemplates: [
                // { // autocasts to FieldColumnTemplate
                //             type: "field",
                //             fieldName: "ObjectId",
                //             direction: "asc", // In order to use initialSortPriority, make sure direction is set
                //             initialSortPriority: 1 // This field's sort order takes the second-highest priority.
                //         },
                {
                    type: "field",
                    fieldName: "art_de",
                    direction: "asc",
                    initialSortPriority: 2
                },
                {
                    type: "field",
                    fieldName: "art_lat"
                },
                {
                    type: "field",
                    fieldName: "dateofobs",
                    direction: "desc", // In order to use initialSortPriority, make sure direction is set
                    initialSortPriority: 0 // This field's sort order takes the highest priority
                },
                {
                    type: "field",
                    fieldName: "bekaempfung"
                },
                {
                    type: "field",
                    fieldName: "praesenz",
                    direction: "asc",
                    initialSortPriority: 1
                },{
                    type: "field",
                    fieldName: "pop_entw",
                    label: "Entwicklung der Population"
                },{
                    type: "field",
                    fieldName: "abundanz"
                },{
                    type: "field",
                    fieldName: "zaehleinheit",
                    direction: "asc",
                    initialSortPriority: 3
                },
                {
                    type: "field",
                    fieldName: "bemerkung"
                }
            ]
        });

        const store = risikoanalyse.getStoreByTopic(appStore.subtopic);
        const featureTable = new FeatureTable({
            view: mapStore.view, // The view property must be set for the select/highlight to work
            layer: store.layer,
            multiSortEnabled: true,
            container: this.tableRef.current,
            editingEnabled: false,
            highlightEnabled: true,
            autoRefreshEnabled: true,
            // hiddenFields: ["projekt", "objectid", "abundanz_bemerkung", "beleg", "beschreibung",
            //     "bestimmung", "deckungsgrad", "foto", "lebensraum", "naturalisierung", "phaenologie",
            //     "vitalitaet", "komplett_abundanz"
            // ],
            tableTemplate
        });

        // export table data
        featureTable.when().then(() => {
            const newMenuItem: ButtonMenuItem = {
                label: "Exportieren",
                clickFunction: (event) => {
                    console.log("Clicked!");
                    this.exportData();
                }
            };
            featureTable.menu.items.push(newMenuItem);
        });

        const popup = new EsriPopup({
            view: mapStore.view,
            container: this.graphRef.current,
            content: featureTable,
        });

        this.setState({
            featureTable,
            popup
        });
    }

    private exportData() {
        this.convertToCSV().then((csv) => {
            if (!csv?.match(/^data:text\/csv/i)) {
                csv = "data:text/csv;charset=utf-8," + csv;
            }
            const filename = "risikoanalyse" + new Date().toISOString() + ".csv";
            const encodedUri = encodeURI(csv);
            const link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", filename);
            link.click();
        });
    }

    private convertToCSV(): Promise<string | null> {
        return new Promise((resolve) => {
            const {featureTable, artNames} = this.state;

            const columnDelimiter = ";";
            const lineDelimiter = "\n";

            let result: string | null;

            // TODO GRK: get data from popup(?) instead of store
            // https://developers.arcgis.com/javascript/3/jsapi/featuretable-amd.html - dataStore is deprecated
            this.getSelectedData().then((data: Building[]) => {
                if (!data || !data.length) {
                    return null;
                }

                const keys: string[] = [];
                featureTable.tableTemplate.columnTemplates.forEach((columnTemplate: any) => {
                    const key = [...Building.databaseFieldNames.entries()].filter((dbFieldName: [string, string]) => {
                        return dbFieldName[1] === columnTemplate.fieldName;
                    })[0][0];
                    keys.push(key);
                });
                console.log("*** keys: " + keys.join(columnDelimiter));

                result = "";
                keys.forEach((key: string) => {
                    // @ts-ignore
                    result += Building.headerNames.get(key);
                    result += columnDelimiter;
                });
                result += "Koordiaten";
                result += lineDelimiter;

                data.forEach((item: any) => {
                    keys.forEach((key, index) => {
                        // get domain from state
                        if (key === "artId") {
                            result += artNames.get(item[key]?.toString());
                            // } else if (key === "bekaempfung") {
                            //     result += bekampfungsmassnahmen.get(item[key]?.toString());
                            // } else if (key === "populationsentwicklung") {
                            //     result += populationsEntwicklung.get(item[key]?.toString());
                            // } else if (key === "zaehleinheit") {
                            //     result += zaehleinheiten.get(item[key]?.toString());
                            // } else if (key === "praesenz") {
                            //     result += artNames.get(item[key]?.toString());
                        } else if (key === "dateOfObservation") {
                            // format date
                            result += Intl.DateTimeFormat("de-DE").format(item[key]);
                        } else {
                            result += item[key];
                        }
                        result += columnDelimiter;
                    });

                    // add coordinates:
                    const xCoord = item.feature.geometry.x;
                    const yCoord = item.feature.geometry.y;
                    result += xCoord.toString() + " / " + yCoord.toString();

                    result += lineDelimiter;
                });
                resolve(result);
            });
        });
    }

    private loadDomains() {
        const {risikoanalyse} = this.props;

        const domainPromises = [
            risikoanalyse.getStringDomainCodes("leitart", "artId"),
            risikoanalyse.getStringDomainCodes("leitart", "bekaempfung"),
            risikoanalyse.getStringDomainCodes("leitart", "populationsentwicklung"),
            risikoanalyse.getStringDomainCodes("leitart", "zaehleinheit"),
            risikoanalyse.getStringDomainCodes("leitart", "praesenz")
        ];

        Promise.all(domainPromises).then((domains) => {
            this.setState({
                artNames: domains[0],
                bekampfungsmassnahmen: domains[1],
                populationsEntwicklung: domains[2],
                zaehleinheiten: domains[3],
                praesenz: domains[4]
            });
        });
    }

    private createGraph(data: any) {
        // Declare the chart dimensions and margins.
        const width = 300;
        const height = 150;
        const marginTop = 10;
        const marginRight = 0;
        const marginBottom = 10;
        const marginLeft = 10;

        // Declare the x (horizontal position) scale.
        const x = d3.scaleBand()
            .domain(d3.groupSort(data, ([d]) => -d.frequency, (d) => d.letter)) // descending frequency
            .range([marginLeft, width - marginRight])
            .padding(0.1);

        // Declare the y (vertical position) scale.
        const y = d3.scaleLinear()
            .domain([0, d3.max(data, (d) => d.frequency)])
            .range([height - marginBottom, marginTop]);

        // Create the SVG container.
        const svg = d3.create("svg")
            .attr("width", width)
            .attr("height", height)
            .attr("viewBox", [0, 0, width, height])
            .attr("style", "max-width: 100%; height: auto;");

        // Add a rect for each bar.
        svg.append("g")
            .attr("fill", "steelblue")
            .selectAll()
            .data(data)
            .join("rect")
            .attr("x", (d) => x(d.letter))
            .attr("y", (d) => y(d.frequency))
            .attr("height", (d) => y(0) - y(d.frequency))
            .attr("width", x.bandwidth());

        // Add the x-axis and label.
        svg.append("g")
            .attr("transform", `translate(0,${height - marginBottom})`)
            .call(d3.axisBottom(x).tickSizeOuter(0));

        // Add the y-axis and label, and remove the domain line.
        svg.append("g")
            .attr("transform", `translate(${marginLeft},0)`)
            .call(d3.axisLeft(y).tickFormat((y) => (y * 100).toFixed()))
            .call((g) => g.select(".domain").remove())
            .call((g) => g.append("text")
                .attr("x", -marginLeft)
                .attr("y", 10)
                .attr("fill", "currentColor")
                .attr("text-anchor", "start")
                .text("↑ Frequency (%)"));

        // Return the SVG element.
        return svg.node();
    }

    private saveSvg(svgEl, name) {
        svgEl.setAttribute("xmlns", "http://www.w3.org/2000/svg");
        const svgData = svgEl.outerHTML;
        const preface = "<?xml version=\"1.0\" standalone=\"no\"?>\r\n";
        const svgBlob = new Blob([preface, svgData], {type: "image/svg+xml;charset=utf-8"});
        const svgUrl = URL.createObjectURL(svgBlob);
        const downloadLink = document.createElement("a");
        downloadLink.href = svgUrl;
        downloadLink.download = name;
        document.body.appendChild(downloadLink);
        downloadLink.click();
    }

    private updateFeatureTableLayer(topic?: TopicConfiguration) {
        const {risikoanalyse} = this.props;
        const {featureTable} = this.state;

        if(!topic || !featureTable) {
            return;
        }

        if (topic.id === this.state.topic) {
            return;
        }
        this.setState({
            topic: topic.id
        });

        const store = risikoanalyse.getStoreByTopic(topic);
        if (!store) {
            return;
        }

        featureTable.layer = store.layer;
        const refreshPromise = featureTable.refresh();
        refreshPromise.catch((error: any) => {
            // TODO: remove as soon as esri fixed the bug in FeatureStore.js
            console.warn(error);
        });

    }

    private getSelectedData(): Promise<[] | Building[] | null> {
        return new Promise((resolve) => {
            const {risikoanalyse, appStore} = this.props;
            const {featureTable} = this.state;

            const geometry = featureTable.filterGeometry;
            const timeExtent = featureTable.timeExtent;

            const store = risikoanalyse.getStoreByTopic(appStore.subtopic);
            store.queryFeaturesFromDb(geometry, timeExtent, "intersects").then((result) => {
                resolve(result);
            });
        });
    }
}
